/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DocumentType model module.
 * @module model/DocumentType
 * @version 1.0.0
 */
class DocumentType {
    /**
     * Constructs a new <code>DocumentType</code>.
     * File documentation type
     * @alias module:model/DocumentType
     * @param id {Number} 
     * @param name {String} 
     */
    constructor(id, name) { 
        
        DocumentType.initialize(this, id, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name) { 
        obj['id'] = id;
        obj['name'] = name;
    }

    /**
     * Constructs a <code>DocumentType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DocumentType} obj Optional instance to populate.
     * @return {module:model/DocumentType} The populated <code>DocumentType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DocumentType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [DocumentType]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
DocumentType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
DocumentType.prototype['name'] = undefined;

/**
 * Document sub types
 * @member {Array.<module:model/DocumentType>} children
 */
DocumentType.prototype['children'] = undefined;






export default DocumentType;

